import { Component, OnInit } from '@angular/core';
import { AuthModalService } from './services/auth.modal.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    doLogin = false;
    doRegister = false;

    constructor(private authModalService: AuthModalService) {}

    ngOnInit(): void {

        this.authModalService.showLogin.subscribe(value => {
            console.log(value);
            this.doLogin = value;
        });
    }

    closeLogin() {
        this.doLogin = false;
        this.doRegister = false;
        this.authModalService.closeLogin();
    }

    switchToRegister() {
        this.doLogin = false;
        this.doRegister = true;
    }

    switchToLogin() {
        this.doLogin = true;
        this.doRegister = false;
    }

}